import React, { useEffect, useRef, useState } from "react";

import {
  uploadAttachFile,
  getAttachFile,
  removeUploadedFile,
} from "controllers/FileController";
import Swal from "sweetalert2";
import Zoom from "react-medium-image-zoom";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import GetAppIcon from "@mui/icons-material/GetApp";
import Resizer from "react-image-file-resizer";
import { setLoading } from "context";
import config from "configs/config";
import getText from "Translator";
import { useMaterialUIController } from "context";
import { Avatar, Button, Grid, TextField } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";

export default function FileAttachComponent(props) {
  const myRef = useRef(null);
  const fileUploader = useRef(null);
  const [file, setFile] = useState();
  const [title, setTitle] = useState("");
  const [datas, setDatas] = useState();
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    (async () => {
      await getUploadedFiles();
    })();
  }, []);

  const getUploadedFiles = async () => {
    try {
      let newData = {
        file: props.file,
      };
      setLoading(dispatch, true);
      let result = await getAttachFile(newData, controller);
      console.log(result);
      setLoading(dispatch, false);
      if (result.success) {
        setDatas(result.data);
      } else {
        Swal.fire({
          text: getText("warningalert", "fa"),
          position: "bottom-end",
          background: "#f1b3af",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
    } catch (err) {
      console.log(err);
    }
  };
  const resizeFile = (file) => console.log(file);
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      700,
      700,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });
  const handleSelectFile = async (event) => {
    try {
      let selectedFilex = event.target.files[0];
      //if (selectedFilex.type) {
      // if (selectedFilex.type.toLowerCase().includes("image")) {
      //   if (selectedFilex.size > 500000) {
      //     selectedFilex = await resizeFile(selectedFilex);
      //   }
      // } else {
      if (selectedFilex.size > 500000) {
        Swal.fire({
          title: getText("warning", "fa"),
          text: getText("filesizewarning500", "fa"),
          confirmButtonText: getText("ok", "fa"),
        });

        return;
      }
      //}
      //}
      setLoading(dispatch, true);
      let result = await uploadAttachFile(
        props.file,
        selectedFilex,
        title,
        controller
      );
      setLoading(dispatch, false);
      if (result.success) {
        setLoading(dispatch, true);
        getUploadedFiles();
        setLoading(dispatch, false);
        Swal.fire({
          text: getText("alertsuccess", "fa"),
          position: "bottom-end",
          background: "#03fca1",
          showConfirmButton: false,
          timer: 1500,
        });
        setTitle("");
      } else {
        Swal.fire({
          text: getText("warningalert", "fa"),
          position: "bottom-end",
          background: "#f1b3af",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      setLoading(dispatch, false);
    } catch (err) {
      console.log(err);
      setLoading(dispatch, false);
    }
  };
  const removeAttachedHandler = async (id) => {
    //
    try {
      Swal.fire({
        title: "",
        text: getText("deleteconfirm", "fa"),
        icon: "info",
        cancelButtonText: getText("cancel", "fa"),
        confirmButtonText: getText("yes", "fa"),
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let newData = {
            id,
          };
          setLoading(dispatch, true);
          let result = await removeUploadedFile(newData, controller);
          setLoading(dispatch, false);
          if (result.success) {
            setLoading(dispatch, true);
            getUploadedFiles();
            setLoading(dispatch, false);
            Swal.fire({
              text: getText("alertsuccess", "fa"),
              position: "bottom-end",
              background: "#03fca1",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            Swal.fire({
              text: getText("warningalert", "fa"),
              position: "bottom-end",
              background: "#f1b3af",
              showConfirmButton: false,
              timer: 1500,
            });
            setLoading(dispatch, false);
            return;
          }
          setLoading(dispatch, false);
        } else {
        }
      });
    } catch (err) {
      console.log(err);
      setLoading(dispatch, false);
    }
  };
  return (
    <>
      <input
        type="file"
        id="file"
        accept="audio/*,video/*,image/*"
        ref={fileUploader}
        onChange={handleSelectFile}
        style={{ display: "none" }}
      />

      <div style={{ width: "100%", height: 55, marginBottom: 10 }} ref={myRef}>
        {props.from === "page" && (
          <Grid container>
            <Grid item xs={9} md={9} style={{ padding: 5 }}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                }}
                label="title"
                key="title"
                id="title"
                fullWidth={true}
                variant="outlined"
                style={{ height: 35, padding: 2 }}
                onChange={(event) => {
                  let text = event.target.value;
                  setTitle(text);
                }}
                value={title}
              />
            </Grid>
            <Grid item xs={3} md={3}>
              <Button
                color="primary"
                className={"iconButton"}
                aria-label="attach"
                startIcon={<AttachFileIcon />}
                onClick={() => {
                  fileUploader.current.click();
                }}
                style={{ width: "100%" }}
              >
                {getText("attach", "fa")}
              </Button>
            </Grid>
          </Grid>
        )}
      </div>
      <Grid container>
        {datas &&
          datas.map((item, index) => (
            <Grid
              item
              xs={2}
              style={{
                marging: 5,
                borderWidth: 3,
                borderColor: "#000",
                borderRadius: 5,
              }}
            >
              <div>
                <div
                  onClick={() => {
                    Swal.fire({
                      text: item.text,
                      position: "bottom",
                      background: "#FFF",
                      showConfirmButton: true,
                    });
                  }}
                  title={item.text}
                  style={{
                    cursor: "pointer",
                    width: "90%",
                    textAlign: "center",

                    height: 30,
                    minHeight: 30,
                    overflow: "hidden",
                    fontSize: 12,
                  }}
                >
                  {item.text}
                </div>
                {(item.attachType === "doc" || item.attachType === "other") && (
                  <a
                    href={config.fileserver + "/files/" + item.address}
                    download
                  >
                    <Avatar
                      style={{
                        width: window.innerWidth / 7,
                        height: window.innerWidth / 7,
                        borderRadius: 0,
                        color: "#039dfc",
                        padding: 5,
                      }}
                      alt={item.text}
                      src={config.fileserver + "/files/" + item.address}
                    >
                      <GetAppIcon />
                    </Avatar>
                  </a>
                )}
                {item.attachType === "image" && (
                  <div
                    style={{
                      width: window.innerWidth / 7,
                      maxHeight: window.innerWidth / 7,
                      borderRadius: 0,
                      color: "#039dfc",
                      padding: 5,
                    }}
                  >
                    <Zoom>
                      <img
                        style={{
                          width: window.innerWidth / 7,
                          borderRadius: 0,
                          color: "#039dfc",
                          padding: 5,
                        }}
                        alt={item.text}
                        src={config.fileserver + "/files/" + item.address}
                      />
                    </Zoom>
                  </div>
                )}
                {props.from === "page" && (
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <Button
                      onClick={() => {
                        removeAttachedHandler(item.id);
                      }}
                    >
                      {getText("delete", "fa")}
                    </Button>
                  </div>
                )}
              </div>
            </Grid>
          ))}
      </Grid>
    </>
  );
}
